import {
  createContext, useContext, ReactNode,
} from 'react';

interface WelcomeUser {
  name: string;
  avatarUrl?: string | null;
}

type ProviderProps = { user?: WelcomeUser; children: ReactNode };

const WelcomeUserContext = createContext<WelcomeUser | undefined>(undefined);

export function useWelcome() {
  return useContext(WelcomeUserContext);
}

export function WelcomeUserProvider({ user, children }: ProviderProps) {
  return (
    <WelcomeUserContext.Provider value={user}>
      {children}
    </WelcomeUserContext.Provider>
  );
}
